<div class="controls-container">
  <div class="controls-header">
    {{ 'CONTROLLERS.HEADER' | translate }}
  </div>

  <div class="controls-grid" *ngIf="controllers?.length && selectedAlarm">
    <button type="button" class="control-btn" *ngFor="let controller of controllers"
      [class.active]="selectedControllerId === controller._id"
      [class.is-success]="controllerState[controller._id] === 'success'"
      [class.is-error]="controllerState[controller._id] === 'error'" [class.is-busy]="executingId === controller._id"
      [disabled]="!!executingId" [style.--btn-color]="controller.color" (click)="onControllerClick(controller)">
      <i class="fa fa-spinner fa-spin" *ngIf="executingId === controller._id" aria-hidden="true"></i>
      <i class="fa" *ngIf="executingId !== controller._id" [ngClass]="controller.icon" aria-hidden="true"></i>
      <span class="control-btn-name">{{ controller.name }}</span>
    </button>
  </div>

  <div class="execute-status" *ngIf="controllers?.length && selectedAlarm && executeMessage" role="status"
    [class.success]="executeSuccess" [class.error]="!executeSuccess">
    <i class="fa execute-status-icon" [ngClass]="executeSuccess ? 'fa-check-circle' : 'fa-exclamation-circle'"
      aria-hidden="true"></i>
    <span class="execute-status-text">{{ executeMessage }}</span>
    <button type="button" class="execute-status-close" (click)="dismissExecuteMessage()"
      [attr.aria-label]="'CONTROLLERS.CLOSE_STATUS' | translate">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="empty-controllers" *ngIf="!controllers?.length || !selectedAlarm">
    {{ 'CONTROLLERS.EMPTY' | translate }}
  </div>
</div>